module.exports = __webpack_public_path__ + "img/services-three-1.71a9528b.jpg";